<template>
  <li>
    <a v-on:click="goDetention" class="block hover:bg-gray-50" :class="detention.outofsync ? 'bg-yellow-50' : ''">
      <div class="pb-0 px-4 py-4 sm:px-6 flex">
        <div 
          v-if="detention.view === 'section'" 
          class="w-38 bg-gray-100 rounded-md text-sm font-semibold text-gray-800 py-2 px-3 flex items-center justify-center mr-4">
          {{ detention.device }}
        </div>
        <div class="flex-1">
          <div class="flex items-center justify-between">
            <p class="2xl:text-sm sm:text-xl font-medium text-indigo-600 truncate">
              {{detention.name}}
            </p>
            <div class="ml-2 flex-shrink-0 flex">
              <p v-if="detention.ispending" class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800">
                {{$store.state.data.devtype === 'mtflow' ? 'En Curso': 'Pendiente'}}
              </p>
              <p v-else class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                OK
              </p>
            </div>
          </div>
          <div class="mt-2 sm:flex sm:justify-between">
            <div class="mt-2 flex items-center 2xl:text-sm sm:text-xl text-gray-500 sm:mt-0">
              <p>
                {{detFormat(detention.start)}} - {{detFormat(detention.end)}} - {{durationFormat(detention.diff)}}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div>
        <detention-buttons :buttons="buttons" :detention="detention" />
      </div>
    </a>
  </li>
</template>
<script>

import { format, parseISO, formatDistance } from 'date-fns'
import esLocale from 'date-fns/locale/es'
import DetentionButtons from '@/components/DetentionButtons'

export default {
  components: { DetentionButtons },
  props: {
    detention: Object
  },
  async created() {
    await this.getButtons()
  },
  methods: {
    async getButtons(){
      const response = await this.$http.get(`flow/custom/formbuttons?method=detentionbutton`)
      this.buttons = response.data.items || []
    },
    detFormat(det) {
      return format(parseISO(det + 'Z'), 'dd/MM/yy HH:mm:ss');
    },
    durationFormat(duration) {
      const result = formatDistance(0,  duration * 1000, {locale: esLocale})
      return result
    },
    goDetention(){
      const detentionData = {
        id: this.detention.id,
        start: this.detention.start,
        end: this.detention.end,
        diff: this.detention.diff,
      }
      this.$store.commit('setState', detentionData)
      this.$router.push('/form/' + this.detention.blueprintid + "/0?detid=" + this.detention.id)
    }
  },
  data(){
    return {
      buttons: []
    }
  }
}
</script>
